import { InfoCardVariants } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';

export const useStyles = makeStyles({
  gridItemCard: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100% - 10px)', // for pages without content header
    marginBottom: '10px',
  },
  fullHeightCard: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  gridItemCardContent: {
    flex: 1,
  },
  fullHeightCardContent: {
    flex: 1,
  },
  bigSkeletonContainer: {
    height: 0,
    overflow: 'hidden',
    paddingTop: '37%',
    position: 'relative',
  },
});

export const getClassFromVariant = (
  classes: ClassNameMap<string>,
  variant?: InfoCardVariants,
) => {
  let cardClass = '';
  let cardContentClass = '';

  if (variant === 'gridItem') {
    cardClass = classes.gridItemCard;
    cardContentClass = classes.gridItemCardContent;
  } else if (variant === 'fullHeight') {
    cardClass = classes.fullHeightCard;
    cardContentClass = classes.fullHeightCardContent;
  }

  return {
    cardClass,
    cardContentClass,
  };
};
